// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_login-container__KBpPh {
  width: 100%;
  height: 100vh;
  display: flex;
  position: relative;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
  background: linear-gradient(135deg, #0a1428 0%, #1a2332 50%, #0c1220 100%);
  overflow: hidden;
}
.Login_login-container__KBpPh.Login_fade-in__tA3iO {
  opacity: 1;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: Login_overlayFadeIn__fSvzR 0.3s ease-out;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c {
  text-align: center;
  color: white;
  position: relative;
  max-width: 400px;
  padding: 40px;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto 30px;
  border: 2px solid rgba(12, 132, 121, 0.3);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(12, 132, 121, 0.1) 0%, transparent 70%);
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-line__49OHU {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 80px;
  background: linear-gradient(to bottom, transparent, #0c8479, #4ade80, #0c8479, transparent);
  transform-origin: 50% 0;
  transform: translate(-50%, -50%) rotate(0deg);
  animation: Login_scannerRotate__uo2fO 2s linear infinite;
  box-shadow: 0 0 10px #0c8479;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 8px;
  width: 60%;
  height: 60%;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE {
  width: 4px;
  height: 4px;
  background: #0c8479;
  border-radius: 50%;
  opacity: 0;
  animation: Login_gridDotPulse__s4XKx 2s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(1) {
  animation-delay: 0s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(2) {
  animation-delay: 0.1s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(3) {
  animation-delay: 0.2s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(4) {
  animation-delay: 0.3s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(5) {
  animation-delay: 0.4s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(6) {
  animation-delay: 0.5s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(7) {
  animation-delay: 0.6s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(8) {
  animation-delay: 0.7s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(9) {
  animation-delay: 0.8s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(10) {
  animation-delay: 0.9s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(11) {
  animation-delay: 1s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(12) {
  animation-delay: 1.1s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(13) {
  animation-delay: 1.2s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(14) {
  animation-delay: 1.3s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(15) {
  animation-delay: 1.4s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(16) {
  animation-delay: 1.5s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(17) {
  animation-delay: 1.6s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(18) {
  animation-delay: 1.7s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(19) {
  animation-delay: 1.8s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(20) {
  animation-delay: 1.9s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(21) {
  animation-delay: 0.1s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(22) {
  animation-delay: 0.3s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(23) {
  animation-delay: 0.5s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(24) {
  animation-delay: 0.7s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 .Login_scanner-grid__TgiW\\+ .Login_grid-dot__iSaQE:nth-child(25) {
  animation-delay: 0.9s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-icon__oQZ4n {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 30px;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-icon__oQZ4n .Login_loading-shield__L\\+8b5 {
  font-size: 48px;
  color: #0c8479;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  animation: Login_shieldPulse__rlwyz 2s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-icon__oQZ4n .Login_loading-ring__1Dr9x {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top: 3px solid #0c8479;
  border-right: 3px solid #0c8479;
  border-radius: 50%;
  animation: Login_ringSpinFast__ikII7 1s linear infinite;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-icon__oQZ4n .Login_loading-ring__1Dr9x::after {
  content: "";
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border: 2px solid transparent;
  border-left: 2px solid #4ade80;
  border-bottom: 2px solid #4ade80;
  border-radius: 50%;
  animation: Login_ringSpinSlow__lUME2 2s linear infinite reverse;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-text__JiT1s {
  margin-bottom: 30px;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-text__JiT1s h3 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  color: white;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-text__JiT1s p {
  font-size: 16px;
  color: #94a3b8;
  margin: 0;
  min-height: 24px;
  animation: Login_textFade__3iukh 0.5s ease-in-out;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-progress__U1RT3 {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  gap: 15px;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-progress__U1RT3 .Login_progress-bar__3Q8IE {
  flex: 1 1;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-progress__U1RT3 .Login_progress-bar__3Q8IE .Login_progress-fill__Q\\+wOz {
  height: 100%;
  background: linear-gradient(90deg, #0c8479, #4ade80);
  border-radius: 2px;
  transition: width 0.8s ease-out;
  position: relative;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-progress__U1RT3 .Login_progress-bar__3Q8IE .Login_progress-fill__Q\\+wOz::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: Login_progressShimmer__AWxtr 2s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-progress__U1RT3 .Login_progress-text__LXSEM {
  font-size: 14px;
  font-weight: 600;
  color: #0c8479;
  min-width: 40px;
  text-align: right;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-dots__xzCBr {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-dots__xzCBr span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0c8479;
  animation: Login_loadingDotBounce__gWtzY 1.4s ease-in-out infinite both;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-dots__xzCBr span:nth-child(1) {
  animation-delay: -0.32s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-dots__xzCBr span:nth-child(2) {
  animation-delay: -0.16s;
}
.Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-dots__xzCBr span:nth-child(3) {
  animation-delay: 0s;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 {
  flex: 1 1;
  background: linear-gradient(135deg, #0c8479 0%, #0a736b 30%, #085a52 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_grid-background__Sx7wb {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: Login_gridMove__SjFLl 20s linear infinite;
  z-index: 0;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_scan-line__mBhQe {
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, transparent 0%, #ffffff 20%, #4ade80 50%, #ffffff 80%, transparent 100%);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  animation: Login_scanMove__4k97U 4s ease-in-out infinite;
  z-index: 1;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.05) 0%, transparent 70%);
  animation: Login_backgroundPulse__zXOOp 8s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce {
  text-align: center;
  color: white;
  z-index: 2;
  position: relative;
  max-width: 450px;
  padding: 40px;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL {
  width: 80px;
  height: 80px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, transparent, #0c8479, transparent);
  animation: Login_ringRotate__LxpbJ 3s linear infinite;
  z-index: -1;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL svg {
  font-size: 32px;
  z-index: 1;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL svg.Login_pulse__0upYU {
  animation: Login_securityPulse__ZhvGM 2s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL svg.Login_rotate__8MXRP {
  animation: Login_securityRotate__Zc99x 1s linear infinite;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL svg.Login_glow__KwpFf {
  animation: Login_securityGlow__EMpWl 2s ease-in-out infinite;
  filter: drop-shadow(0 0 10px currentColor);
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL svg.Login_success__gmvMK {
  color: #4ade80;
  animation: Login_successPulse__vXPdS 0.6s ease-in-out;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL svg.Login_error__MaX-D {
  color: #f87171;
  animation: Login_errorShake__i\\+HVa 0.6s ease-in-out;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_logo__-MCLA {
  width: 220px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_logo__-MCLA:hover {
  transform: scale(1.05);
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs {
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
  min-height: 80px;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs .Login_typing-text__muf5D {
  display: inline-block;
  position: relative;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs .Login_typing-text__muf5D .Login_cursor__dTUp2 {
  display: inline-block;
  color: #4ade80;
  font-weight: 400;
  margin-left: 2px;
  opacity: 0;
  transition: opacity 0.1s ease;
  text-shadow: 0 0 8px #4ade80;
  animation: Login_cursorGlow__fbrvV 2s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs .Login_typing-text__muf5D .Login_cursor__dTUp2.Login_visible__IQSdu {
  opacity: 1;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs .Login_typing-text__muf5D.Login_typing-complete__dH0v9 {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3), 0 0 20px rgba(255, 255, 255, 0.2);
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs .Login_typing-text__muf5D.Login_typing-complete__dH0v9 .Login_cursor__dTUp2 {
  display: none;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-subtitle__emUJn {
  font-size: 18px;
  opacity: 0.9;
  margin-bottom: 30px;
  line-height: 1.4;
  animation: Login_fadeInUp__5uC8K 1s ease-out 2s both;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-status__uy6iC {
  margin-bottom: 30px;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-status__uy6iC .Login_status-indicator__gEB9y {
  display: flex;
  align-items: center;
  gap: 12px;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-status__uy6iC .Login_status-indicator__gEB9y .Login_status-light__zioIu {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4ade80;
  animation: Login_statusBlink__JgvWn 2s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-status__uy6iC .Login_status-indicator__gEB9y .Login_status-text__aWNDB {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-features__SzvaI {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-features__SzvaI .Login_feature__2xXRN {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  opacity: 0.9;
  position: relative;
  animation: Login_slideInLeft__XFIH2 0.6s ease-out both;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-features__SzvaI .Login_feature__2xXRN:nth-child(1) {
  animation-delay: 3s;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-features__SzvaI .Login_feature__2xXRN:nth-child(2) {
  animation-delay: 3.2s;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-features__SzvaI .Login_feature__2xXRN:nth-child(3) {
  animation-delay: 3.4s;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-features__SzvaI .Login_feature__2xXRN svg {
  font-size: 20px;
  color: #4ade80;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-features__SzvaI .Login_feature__2xXRN .Login_feature-bar__ftxs1 {
  position: absolute;
  bottom: -5px;
  left: 32px;
  height: 2px;
  background: linear-gradient(90deg, #0c8479, transparent);
  width: 0;
  animation: Login_barGrow__XcKgi 1s ease-out 0.5s both;
}
.Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_circuit-pattern__vvpS8 {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 100px;
  height: 100px;
  opacity: 0.1;
  background-image: linear-gradient(90deg, white 1px, transparent 1px), linear-gradient(white 1px, transparent 1px);
  background-size: 10px 10px;
  animation: Login_circuitGlow__b3cyV 4s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb {
  flex: 1 1;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.2);
  position: relative;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 100%;
  background: linear-gradient(to bottom, transparent, #0c8479, transparent);
  animation: Login_borderGlow__jW\\+z2 3s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK {
  width: 100%;
  max-width: 420px;
  padding: 60px 40px;
  animation: Login_slideInRight__mBdHP 0.8s ease-out 0.5s both;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph {
  text-align: center;
  margin-bottom: 40px;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_access-indicator__E3LLi {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_access-indicator__E3LLi .Login_access-dots__TS0Mh {
  display: flex;
  gap: 4px;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_access-indicator__E3LLi .Login_access-dots__TS0Mh span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0c8479;
  animation: Login_dotPulse__tx--u 1.5s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_access-indicator__E3LLi .Login_access-dots__TS0Mh span:nth-child(1) {
  animation-delay: 0s;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_access-indicator__E3LLi .Login_access-dots__TS0Mh span:nth-child(2) {
  animation-delay: 0.2s;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_access-indicator__E3LLi .Login_access-dots__TS0Mh span:nth-child(3) {
  animation-delay: 0.4s;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_access-indicator__E3LLi > span {
  font-size: 12px;
  font-weight: 600;
  color: #0c8479;
  letter-spacing: 1px;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_login-title__i\\+aCA {
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_login-subtitle__rb2SR {
  font-size: 16px;
  color: #64748b;
  margin: 0;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 {
  margin-bottom: 24px;
  position: relative;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 .Login_input-scanner__8SiVi {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #0c8479, transparent);
  transform: translateX(-100%);
  animation: Login_inputScan__mNzTn 3s ease-in-out infinite;
  z-index: 1;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 .Login_form-input__LsgZg {
  position: relative;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 .Login_form-input__LsgZg input {
  height: 54px !important;
  border-radius: 12px !important;
  border: 2px solid #e2e8f0 !important;
  font-size: 16px !important;
  transition: all 0.3s ease !important;
  background: #ffffff !important;
  position: relative;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 .Login_form-input__LsgZg input:focus {
  border-color: #0c8479 !important;
  box-shadow: 0 0 0 4px rgba(12, 132, 121, 0.1) !important;
  background: white !important;
  transform: translateY(-1px);
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 .Login_form-input__LsgZg input:hover {
  border-color: #cbd5e1 !important;
  transform: translateY(-1px);
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 .Login_form-input__LsgZg label {
  font-weight: 600 !important;
  color: #374151 !important;
  margin-bottom: 8px !important;
  font-size: 14px !important;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq {
  margin-top: 32px;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq button {
  height: 54px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg, #0c8479 0%, #0a736b 100%) !important;
  border: none !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 15px rgba(12, 132, 121, 0.3) !important;
  position: relative;
  overflow: hidden;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(12, 132, 121, 0.4) !important;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq button:hover::before {
  left: 100%;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq button:active {
  transform: translateY(0) !important;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq button:disabled {
  opacity: 0.8 !important;
  transform: none !important;
  box-shadow: 0 2px 10px rgba(12, 132, 121, 0.2) !important;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq button.Login_loading__MkPQ2 {
  animation: Login_buttonPulse__rl9jr 1.5s ease-in-out infinite;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH {
  margin-top: 40px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH .Login_security-badges__DvaI6 {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH .Login_security-badges__DvaI6 .Login_badge__uVoAv {
  padding: 4px 12px;
  background: #f1f5f9;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid #e2e8f0;
  animation: Login_fadeInUp__5uC8K 0.6s ease-out both;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH .Login_security-badges__DvaI6 .Login_badge__uVoAv:nth-child(1) {
  animation-delay: 4s;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH .Login_security-badges__DvaI6 .Login_badge__uVoAv:nth-child(2) {
  animation-delay: 4.2s;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH .Login_security-badges__DvaI6 .Login_badge__uVoAv:nth-child(3) {
  animation-delay: 4.4s;
}
.Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH p {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
}

@keyframes Login_overlayFadeIn__fSvzR {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes Login_scannerRotate__uo2fO {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
@keyframes Login_gridDotPulse__s4XKx {
  0%, 100% {
    opacity: 0;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}
@keyframes Login_shieldPulse__rlwyz {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }
}
@keyframes Login_ringSpinFast__ikII7 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes Login_ringSpinSlow__lUME2 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
@keyframes Login_textFade__3iukh {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes Login_progressShimmer__AWxtr {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes Login_loadingDotBounce__gWtzY {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
@keyframes Login_gridMove__SjFLl {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}
@keyframes Login_scanMove__4k97U {
  0% {
    left: 0;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}
@keyframes Login_backgroundPulse__zXOOp {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
@keyframes Login_ringRotate__LxpbJ {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes Login_securityPulse__ZhvGM {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
}
@keyframes Login_securityRotate__Zc99x {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes Login_securityGlow__EMpWl {
  0%, 100% {
    text-shadow: 0 0 5px currentColor;
  }
  50% {
    text-shadow: 0 0 20px currentColor, 0 0 30px currentColor;
  }
}
@keyframes Login_successPulse__vXPdS {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes Login_errorShake__i\\+HVa {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}
@keyframes Login_fadeInUp__5uC8K {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes Login_slideInLeft__XFIH2 {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes Login_slideInRight__mBdHP {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes Login_statusBlink__JgvWn {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
@keyframes Login_barGrow__XcKgi {
  from {
    width: 0;
  }
  to {
    width: calc(100% - 32px);
  }
}
@keyframes Login_circuitGlow__b3cyV {
  0%, 100% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.3;
  }
}
@keyframes Login_borderGlow__jW\\+z2 {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes Login_dotPulse__tx--u {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}
@keyframes Login_inputScan__mNzTn {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes Login_buttonPulse__rl9jr {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(12, 132, 121, 0.3);
  }
  50% {
    box-shadow: 0 6px 20px rgba(12, 132, 121, 0.5);
  }
}
@keyframes Login_cursorGlow__fbrvV {
  0%, 100% {
    text-shadow: 0 0 8px #4ade80;
    transform: scale(1);
  }
  50% {
    text-shadow: 0 0 15px #4ade80, 0 0 25px #4ade80;
    transform: scale(1.05);
  }
}
@media (max-width: 1024px) {
  .Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c {
    padding: 30px 20px;
    max-width: 350px;
  }
  .Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 {
    width: 150px;
    height: 150px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce {
    padding: 30px;
    max-width: 380px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs {
    font-size: 30px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-subtitle__emUJn {
    font-size: 16px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK {
    padding: 40px 30px;
    max-width: 380px;
  }
}
@media (max-width: 768px) {
  .Login_login-container__KBpPh {
    flex-direction: column;
  }
  .Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c {
    padding: 20px;
  }
  .Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 {
    width: 120px;
    height: 120px;
    margin-bottom: 20px;
  }
  .Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-text__JiT1s h3 {
    font-size: 20px;
  }
  .Login_login-container__KBpPh .Login_scan-line__mBhQe {
    display: none;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 {
    flex: 0 0 45%;
    min-height: 45vh;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce {
    padding: 20px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 {
    margin-bottom: 20px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL {
    width: 60px;
    height: 60px;
    margin-bottom: 15px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_security-ring__kXIqL svg {
    font-size: 24px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-logo__CuOC7 .Login_logo__-MCLA {
    width: 160px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-subtitle__emUJn {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-status__uy6iC,
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_security-features__SzvaI,
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_circuit-pattern__vvpS8 {
    display: none;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb {
    flex: 1 1;
    box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.1);
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK {
    padding: 30px 20px;
    max-width: 100%;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph {
    margin-bottom: 30px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_login-title__i\\+aCA {
    font-size: 24px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_login-subtitle__rb2SR {
    font-size: 14px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_input-group__5Qkc9 {
    margin-bottom: 20px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-form__XkcPR .Login_login-button__9zGQq {
    margin-top: 20px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH {
    margin-top: 30px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-footer__\\+PtkH .Login_security-badges__DvaI6 .Login_badge__uVoAv {
    font-size: 10px;
    padding: 3px 8px;
  }
}
@media (max-width: 480px) {
  .Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-scanner__mmGw6 {
    width: 100px;
    height: 100px;
  }
  .Login_login-container__KBpPh .Login_loading-overlay__CjHtp .Login_loading-content__l4-8c .Login_loading-text__JiT1s h3 {
    font-size: 18px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 {
    min-height: 40vh;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-title__xCYDs {
    font-size: 20px;
  }
  .Login_login-container__KBpPh .Login_login-brand__gqAq6 .Login_brand-content__GGUce .Login_brand-subtitle__emUJn {
    font-size: 13px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK {
    padding: 20px 15px;
  }
  .Login_login-container__KBpPh .Login_login-panel__VsVIb .Login_login-content__L7paK .Login_login-header__-UIph .Login_login-title__i\\+aCA {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/auth/Login/Login.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,oCAAA;EACA,0EAAA;EACA,gBAAA;AACJ;AACI;EACI,UAAA;AACR;AAGI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mDAAA;AADR;AAGQ;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AADZ;AAGY;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,gFAAA;AADhB;AAGgB;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,2FAAA;EACA,uBAAA;EACA,6CAAA;EACA,wDAAA;EACA,4BAAA;AADpB;AAIgB;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AAFpB;AAIoB;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,4DAAA;AAFxB;AAIwB;EAAiB,mBAAA;AADzC;AAEwB;EAAiB,qBAAA;AACzC;AAAwB;EAAiB,qBAAA;AAGzC;AAFwB;EAAiB,qBAAA;AAKzC;AAJwB;EAAiB,qBAAA;AAOzC;AANwB;EAAiB,qBAAA;AASzC;AARwB;EAAiB,qBAAA;AAWzC;AAVwB;EAAiB,qBAAA;AAazC;AAZwB;EAAiB,qBAAA;AAezC;AAdwB;EAAkB,qBAAA;AAiB1C;AAhBwB;EAAkB,mBAAA;AAmB1C;AAlBwB;EAAkB,qBAAA;AAqB1C;AApBwB;EAAkB,qBAAA;AAuB1C;AAtBwB;EAAkB,qBAAA;AAyB1C;AAxBwB;EAAkB,qBAAA;AA2B1C;AA1BwB;EAAkB,qBAAA;AA6B1C;AA5BwB;EAAkB,qBAAA;AA+B1C;AA9BwB;EAAkB,qBAAA;AAiC1C;AAhCwB;EAAkB,qBAAA;AAmC1C;AAlCwB;EAAkB,qBAAA;AAqC1C;AApCwB;EAAkB,qBAAA;AAuC1C;AAtCwB;EAAkB,qBAAA;AAyC1C;AAxCwB;EAAkB,qBAAA;AA2C1C;AA1CwB;EAAkB,qBAAA;AA6C1C;AA5CwB;EAAkB,qBAAA;AA+C1C;AA1CY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA4ChB;AA1CgB;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,2DAAA;AA4CpB;AAzCgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,uDAAA;AA2CpB;AAzCoB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,gCAAA;EACA,kBAAA;EACA,+DAAA;AA2CxB;AAtCY;EACI,mBAAA;AAwChB;AAtCgB;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAwCpB;AArCgB;EACI,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,iDAAA;AAuCpB;AAnCY;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAqChB;AAnCgB;EACI,SAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAqCpB;AAnCoB;EACI,YAAA;EACA,oDAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;AAqCxB;AAnCwB;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sFAAA;EACA,+DAAA;AAqC5B;AAhCgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAkCpB;AA9BY;EACI,aAAA;EACA,uBAAA;EACA,QAAA;AAgChB;AA9BgB;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,uEAAA;AAgCpB;AA9BoB;EAAiB,uBAAA;AAiCrC;AAhCoB;EAAiB,uBAAA;AAmCrC;AAlCoB;EAAiB,mBAAA;AAqCrC;AA9BI;EACI,SAAA;EACA,0EAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAgCR;AA7BQ;EACI,kBAAA;EACJ,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACI,uJACI;EAEJ,0BAAA;EACA,oDAAA;EACA,UAAA;AA6BZ;AAzBQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,+GAAA;EAMA,6CAAA;EACA,wDAAA;EACA,UAAA;AAsBZ;AAnBQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uQACI;EAGJ,+DAAA;AAkBZ;AAfQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAiBZ;AAfY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAiBhB;AAfgB;EACI,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,2BAAA;AAiBpB;AAfoB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wEAAA;EACA,qDAAA;EACA,WAAA;AAiBxB;AAdoB;EACI,eAAA;EACA,UAAA;AAgBxB;AAdwB;EACI,6DAAA;AAgB5B;AAbwB;EACI,yDAAA;AAe5B;AAZwB;EACI,4DAAA;EACA,0CAAA;AAc5B;AAXwB;EACI,cAAA;EACA,qDAAA;AAa5B;AAVwB;EACI,cAAA;EACA,oDAAA;AAY5B;AAPY;EACQ,YAAA;EACJ,YAAA;EACI,iDAAA;EACJ,+BAAA;AAShB;AAPgB;EACI,sBAAA;AASpB;AAJY;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAMhB;AAJgB;EACI,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,yCAAA;AAMpB;AAJoB;EACI,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,4BAAA;EACA,0DAAA;AAMxB;AAJwB;EACI,UAAA;AAM5B;AAFoB;EAKI,4EACI;AAD5B;AAJwB;EACI,aAAA;AAM5B;AAIY;EACI,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,oDAAA;AAFhB;AAKY;EACI,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,2BAAA;EACA,0CAAA;AAHhB;AAKgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAHpB;AAKoB;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,2DAAA;AAHxB;AAMoB;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAJxB;AASY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAPhB;AASgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,sDAAA;AAPpB;AASoB;EAAiB,mBAAA;AANrC;AAOoB;EAAiB,qBAAA;AAJrC;AAKoB;EAAiB,qBAAA;AAFrC;AAIoB;EACI,eAAA;EACA,cAAA;AAFxB;AAKoB;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wDAAA;EACA,QAAA;EACA,qDAAA;AAHxB;AAQY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iHACI;EAEJ,0BAAA;EACA,2DAAA;AARhB;AAcI;EACI,SAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,kBAAA;AAZR;AAcQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yEAAA;EACA,2DAAA;AAZZ;AAeQ;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AAbZ;AAeY;EACI,kBAAA;EACA,mBAAA;AAbhB;AAegB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAbpB;AAeoB;EACI,aAAA;EACA,QAAA;AAbxB;AAewB;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,0DAAA;AAb5B;AAe4B;EAAiB,mBAAA;AAZ7C;AAa4B;EAAiB,qBAAA;AAV7C;AAW4B;EAAiB,qBAAA;AAR7C;AAYoB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAVxB;AAcgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAZpB;AAegB;EACI,eAAA;EACA,cAAA;EACA,SAAA;AAbpB;AAkBgB;EACI,mBAAA;EACA,kBAAA;AAhBpB;AAkBoB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,qEAAA;EACA,4BAAA;EACA,yDAAA;EACA,UAAA;AAhBxB;AAmBoB;EACI,kBAAA;AAjBxB;AAmBwB;EACI,uBAAA;EACA,8BAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EACA,8BAAA;EACA,kBAAA;AAjB5B;AAmB4B;EACI,gCAAA;EACA,wDAAA;EACA,4BAAA;EACA,2BAAA;AAjBhC;AAoB4B;EACI,gCAAA;EACA,2BAAA;AAlBhC;AAsBwB;EACI,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,0BAAA;AApB5B;AAyBgB;EACI,gBAAA;AAvBpB;AAyBoB;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,wEAAA;EACA,uBAAA;EACA,oCAAA;EACA,yDAAA;EACA,kBAAA;EACA,gBAAA;AAvBxB;AAyBwB;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;AAvB5B;AA0BwB;EACI,sCAAA;EACA,yDAAA;AAxB5B;AA0B4B;EACI,UAAA;AAxBhC;AA4BwB;EACI,mCAAA;AA1B5B;AA6BwB;EACI,uBAAA;EACA,0BAAA;EACA,yDAAA;AA3B5B;AA8BwB;EACI,6DAAA;AA5B5B;AAkCY;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AAhChB;AAkCgB;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAhCpB;AAkCoB;EACI,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mDAAA;AAhCxB;AAkCwB;EAAiB,mBAAA;AA/BzC;AAgCwB;EAAiB,qBAAA;AA7BzC;AA8BwB;EAAiB,qBAAA;AA3BzC;AA+BgB;EACI,eAAA;EACA,cAAA;EACA,SAAA;AA7BpB;;AAqCA;EACI;IAAO,UAAA;EAjCT;EAkCE;IAAK,UAAA;EA/BP;AACF;AAiCA;EACI;IAAO,6CAAA;EA9BT;EA+BE;IAAK,+CAAA;EA5BP;AACF;AA8BA;EACI;IAAW,UAAA;IAAY,mBAAA;EA1BzB;EA2BE;IAAM,UAAA;IAAY,qBAAA;EAvBpB;AACF;AAyBA;EACI;IAAW,yCAAA;EAtBb;EAuBE;IAAM,2CAAA;EApBR;AACF;AAsBA;EACI;IAAO,uBAAA;EAnBT;EAoBE;IAAK,yBAAA;EAjBP;AACF;AAmBA;EACI;IAAO,uBAAA;EAhBT;EAiBE;IAAK,0BAAA;EAdP;AACF;AAgBA;EACI;IAAO,UAAA;IAAY,2BAAA;EAZrB;EAaE;IAAK,UAAA;IAAY,wBAAA;EATnB;AACF;AAWA;EACI;IAAK,4BAAA;EARP;EASE;IAAO,2BAAA;EANT;AACF;AAQA;EACI;IAAgB,mBAAA;EALlB;EAME;IAAM,mBAAA;EAHR;AACF;AAMA;EACI;IAAK,0BAAA;EAHP;EAIE;IAAO,gCAAA;EADT;AACF;AAGA;EACI;IAAK,OAAA;IAAS,UAAA;EAChB;EAAE;IAAM,UAAA;EAGR;EAFE;IAAM,UAAA;EAKR;EAJE;IAAO,UAAA;IAAY,UAAA;EAQrB;AACF;AANA;EACI;IAAW,UAAA;EASb;EARE;IAAM,YAAA;EAWR;AACF;AATA;EACI;IAAO,uBAAA;EAYT;EAXE;IAAK,yBAAA;EAcP;AACF;AAZA;EACI;IAAW,mBAAA;IAAqB,UAAA;EAgBlC;EAfE;IAAM,qBAAA;IAAuB,YAAA;EAmB/B;AACF;AAjBA;EACI;IAAO,uBAAA;EAoBT;EAnBE;IAAK,yBAAA;EAsBP;AACF;AApBA;EACI;IAAW,iCAAA;EAuBb;EAtBE;IAAM,yDAAA;EAyBR;AACF;AAvBA;EACI;IAAK,mBAAA;EA0BP;EAzBE;IAAM,qBAAA;EA4BR;EA3BE;IAAO,mBAAA;EA8BT;AACF;AA5BA;EACI;IAAW,wBAAA;EA+Bb;EA9BE;IAAM,2BAAA;EAiCR;EAhCE;IAAM,0BAAA;EAmCR;AACF;AAjCA;EACI;IAAO,UAAA;IAAY,2BAAA;EAqCrB;EApCE;IAAK,UAAA;IAAY,wBAAA;EAwCnB;AACF;AAtCA;EACI;IAAO,UAAA;IAAY,4BAAA;EA0CrB;EAzCE;IAAK,UAAA;IAAY,wBAAA;EA6CnB;AACF;AA3CA;EACI;IAAO,UAAA;IAAY,2BAAA;EA+CrB;EA9CE;IAAK,UAAA;IAAY,wBAAA;EAkDnB;AACF;AAhDA;EACI;IAAW,UAAA;EAmDb;EAlDE;IAAM,YAAA;EAqDR;AACF;AAnDA;EACI;IAAO,QAAA;EAsDT;EArDE;IAAK,wBAAA;EAwDP;AACF;AAtDA;EACI;IAAW,YAAA;EAyDb;EAxDE;IAAM,YAAA;EA2DR;AACF;AAzDA;EACI;IAAW,YAAA;EA4Db;EA3DE;IAAM,UAAA;EA8DR;AACF;AA5DA;EACI;IAAW,YAAA;IAAc,mBAAA;EAgE3B;EA/DE;IAAM,UAAA;IAAY,qBAAA;EAmEpB;AACF;AAjEA;EACI;IAAK,4BAAA;EAoEP;EAnEE;IAAO,2BAAA;EAsET;AACF;AApEA;EACI;IAAW,8CAAA;EAuEb;EAtEE;IAAM,8CAAA;EAyER;AACF;AAvEA;EACI;IACI,4BAAA;IACA,mBAAA;EAyEN;EAvEE;IACI,+CAAA;IACA,sBAAA;EAyEN;AACF;AArEA;EAGY;IACI,kBAAA;IACA,gBAAA;EAqEd;EAnEc;IACI,YAAA;IACA,aAAA;EAqElB;EA/DU;IACI,aAAA;IACA,gBAAA;EAiEd;EA/Dc;IACI,eAAA;EAiElB;EA9Dc;IACI,eAAA;EAgElB;EA1DU;IACI,kBAAA;IACA,gBAAA;EA4Dd;AACF;AAvDA;EACI;IACI,sBAAA;EAyDN;EAtDU;IACI,aAAA;EAwDd;EAtDc;IACI,YAAA;IACA,aAAA;IACA,mBAAA;EAwDlB;EArDc;IACI,eAAA;EAuDlB;EAlDM;IACI,aAAA;EAoDV;EAjDM;IACI,aAAA;IACA,gBAAA;EAmDV;EAjDU;IACI,aAAA;EAmDd;EAjDc;IACI,mBAAA;EAmDlB;EAjDkB;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EAmDtB;EAjDsB;IACI,eAAA;EAmD1B;EA/CkB;IACI,YAAA;EAiDtB;EA7Cc;IACI,eAAA;IACA,mBAAA;EA+ClB;EA5Cc;IACI,eAAA;IACA,mBAAA;EA8ClB;EA3Cc;;;IAGI,aAAA;EA6ClB;EAxCM;IACI,SAAA;IACA,2CAAA;EA0CV;EAxCU;IACI,kBAAA;IACA,eAAA;EA0Cd;EAxCc;IACI,mBAAA;EA0ClB;EAxCkB;IACI,eAAA;EA0CtB;EAvCkB;IACI,eAAA;EAyCtB;EApCkB;IACI,mBAAA;EAsCtB;EAnCkB;IACI,gBAAA;EAqCtB;EAjCc;IACI,gBAAA;EAmClB;EAhCsB;IACI,eAAA;IACA,gBAAA;EAkC1B;AACF;AA1BA;EAIgB;IACI,YAAA;IACA,aAAA;EAyBlB;EAtBc;IACI,eAAA;EAwBlB;EAnBM;IACI,gBAAA;EAqBV;EAlBc;IACI,eAAA;EAoBlB;EAjBc;IACI,eAAA;EAmBlB;EAbU;IACI,kBAAA;EAed;EAZkB;IACI,eAAA;EActB;AACF","sourcesContent":[".login-container {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    position: relative;\n    opacity: 0;\n    transition: opacity 0.8s ease-in-out;\n    background: linear-gradient(135deg, #0a1428 0%, #1a2332 50%, #0c1220 100%);\n    overflow: hidden;\n\n    &.fade-in {\n        opacity: 1;\n    }\n\n    // Loading Overlay\n    .loading-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100vw;\n        height: 100vh;\n        background: rgba(0, 0, 0, 0.95);\n        backdrop-filter: blur(10px);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 9999;\n        animation: overlayFadeIn 0.3s ease-out;\n\n        .loading-content {\n            text-align: center;\n            color: white;\n            position: relative;\n            max-width: 400px;\n            padding: 40px;\n\n            .loading-scanner {\n                position: relative;\n                width: 200px;\n                height: 200px;\n                margin: 0 auto 30px;\n                border: 2px solid rgba(12, 132, 121, 0.3);\n                border-radius: 50%;\n                background: radial-gradient(circle, rgba(12, 132, 121, 0.1) 0%, transparent 70%);\n\n                .scanner-line {\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    width: 2px;\n                    height: 80px;\n                    background: linear-gradient(to bottom, transparent, #0c8479, #4ade80, #0c8479, transparent);\n                    transform-origin: 50% 0;\n                    transform: translate(-50%, -50%) rotate(0deg);\n                    animation: scannerRotate 2s linear infinite;\n                    box-shadow: 0 0 10px #0c8479;\n                }\n\n                .scanner-grid {\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%);\n                    display: grid;\n                    grid-template-columns: repeat(5, 1fr);\n                    grid-template-rows: repeat(5, 1fr);\n                    gap: 8px;\n                    width: 60%;\n                    height: 60%;\n\n                    .grid-dot {\n                        width: 4px;\n                        height: 4px;\n                        background: #0c8479;\n                        border-radius: 50%;\n                        opacity: 0;\n                        animation: gridDotPulse 2s ease-in-out infinite;\n\n                        &:nth-child(1) { animation-delay: 0s; }\n                        &:nth-child(2) { animation-delay: 0.1s; }\n                        &:nth-child(3) { animation-delay: 0.2s; }\n                        &:nth-child(4) { animation-delay: 0.3s; }\n                        &:nth-child(5) { animation-delay: 0.4s; }\n                        &:nth-child(6) { animation-delay: 0.5s; }\n                        &:nth-child(7) { animation-delay: 0.6s; }\n                        &:nth-child(8) { animation-delay: 0.7s; }\n                        &:nth-child(9) { animation-delay: 0.8s; }\n                        &:nth-child(10) { animation-delay: 0.9s; }\n                        &:nth-child(11) { animation-delay: 1s; }\n                        &:nth-child(12) { animation-delay: 1.1s; }\n                        &:nth-child(13) { animation-delay: 1.2s; }\n                        &:nth-child(14) { animation-delay: 1.3s; }\n                        &:nth-child(15) { animation-delay: 1.4s; }\n                        &:nth-child(16) { animation-delay: 1.5s; }\n                        &:nth-child(17) { animation-delay: 1.6s; }\n                        &:nth-child(18) { animation-delay: 1.7s; }\n                        &:nth-child(19) { animation-delay: 1.8s; }\n                        &:nth-child(20) { animation-delay: 1.9s; }\n                        &:nth-child(21) { animation-delay: 0.1s; }\n                        &:nth-child(22) { animation-delay: 0.3s; }\n                        &:nth-child(23) { animation-delay: 0.5s; }\n                        &:nth-child(24) { animation-delay: 0.7s; }\n                        &:nth-child(25) { animation-delay: 0.9s; }\n                    }\n                }\n            }\n\n            .loading-icon {\n                position: relative;\n                width: 80px;\n                height: 80px;\n                margin: 0 auto 30px;\n\n                .loading-shield {\n                    font-size: 48px;\n                    color: #0c8479;\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%);\n                    z-index: 2;\n                    animation: shieldPulse 2s ease-in-out infinite;\n                }\n\n                .loading-ring {\n                    position: absolute;\n                    width: 100%;\n                    height: 100%;\n                    border: 3px solid transparent;\n                    border-top: 3px solid #0c8479;\n                    border-right: 3px solid #0c8479;\n                    border-radius: 50%;\n                    animation: ringSpinFast 1s linear infinite;\n\n                    &::after {\n                        content: '';\n                        position: absolute;\n                        top: -3px;\n                        left: -3px;\n                        right: -3px;\n                        bottom: -3px;\n                        border: 2px solid transparent;\n                        border-left: 2px solid #4ade80;\n                        border-bottom: 2px solid #4ade80;\n                        border-radius: 50%;\n                        animation: ringSpinSlow 2s linear infinite reverse;\n                    }\n                }\n            }\n\n            .loading-text {\n                margin-bottom: 30px;\n\n                h3 {\n                    font-size: 24px;\n                    font-weight: 600;\n                    margin-bottom: 10px;\n                    color: white;\n                }\n\n                p {\n                    font-size: 16px;\n                    color: #94a3b8;\n                    margin: 0;\n                    min-height: 24px;\n                    animation: textFade 0.5s ease-in-out;\n                }\n            }\n\n            .loading-progress {\n                margin-bottom: 30px;\n                display: flex;\n                align-items: center;\n                gap: 15px;\n\n                .progress-bar {\n                    flex: 1;\n                    height: 4px;\n                    background: rgba(255, 255, 255, 0.1);\n                    border-radius: 2px;\n                    overflow: hidden;\n                    position: relative;\n\n                    .progress-fill {\n                        height: 100%;\n                        background: linear-gradient(90deg, #0c8479, #4ade80);\n                        border-radius: 2px;\n                        transition: width 0.8s ease-out;\n                        position: relative;\n\n                        &::after {\n                            content: '';\n                            position: absolute;\n                            top: 0;\n                            left: 0;\n                            right: 0;\n                            bottom: 0;\n                            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n                            animation: progressShimmer 2s ease-in-out infinite;\n                        }\n                    }\n                }\n\n                .progress-text {\n                    font-size: 14px;\n                    font-weight: 600;\n                    color: #0c8479;\n                    min-width: 40px;\n                    text-align: right;\n                }\n            }\n\n            .loading-dots {\n                display: flex;\n                justify-content: center;\n                gap: 8px;\n\n                span {\n                    width: 8px;\n                    height: 8px;\n                    border-radius: 50%;\n                    background: #0c8479;\n                    animation: loadingDotBounce 1.4s ease-in-out infinite both;\n\n                    &:nth-child(1) { animation-delay: -0.32s; }\n                    &:nth-child(2) { animation-delay: -0.16s; }\n                    &:nth-child(3) { animation-delay: 0s; }\n                }\n            }\n        }\n    }\n\n    // Left side - Branding\n    .login-brand {\n        flex: 1;\n        background: linear-gradient(135deg, #0c8479 0%, #0a736b 30%, #085a52 100%);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        overflow: hidden;\n\n        // Animated Grid Background - only in left panel\n        .grid-background {\n            position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n            background-image: \n                linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),\n                linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);\n            background-size: 50px 50px;\n            animation: gridMove 20s linear infinite;\n            z-index: 0;\n        }\n\n        // Security Scanning Line - only in left panel\n        .scan-line {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 2px;\n            height: 100%;\n            background: linear-gradient(to bottom, \n                transparent 0%, \n                #ffffff 20%, \n                #4ade80 50%, \n                #ffffff 80%, \n                transparent 100%);\n            box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);\n            animation: scanMove 4s ease-in-out infinite;\n            z-index: 1;\n        }\n        \n        &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            background-image: \n                radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%),\n                radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%),\n                radial-gradient(circle at 40% 40%, rgba(255,255,255,0.05) 0%, transparent 70%);\n            animation: backgroundPulse 8s ease-in-out infinite;\n        }\n\n        .brand-content {\n            text-align: center;\n            color: white;\n            z-index: 2;\n            position: relative;\n            max-width: 450px;\n            padding: 40px;\n\n            .brand-logo {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                margin-bottom: 40px;\n\n                .security-ring {\n                    width: 80px;\n                    height: 80px;\n                    border: 2px solid rgba(255, 255, 255, 0.3);\n                    border-radius: 50%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    margin-bottom: 20px;\n                    position: relative;\n                    background: rgba(255, 255, 255, 0.1);\n                    backdrop-filter: blur(10px);\n\n                    &::before {\n                        content: '';\n                        position: absolute;\n                        top: -2px;\n                        left: -2px;\n                        right: -2px;\n                        bottom: -2px;\n                        border-radius: 50%;\n                        background: conic-gradient(from 0deg, transparent, #0c8479, transparent);\n                        animation: ringRotate 3s linear infinite;\n                        z-index: -1;\n                    }\n\n                    svg {\n                        font-size: 32px;\n                        z-index: 1;\n                        \n                        &.pulse {\n                            animation: securityPulse 2s ease-in-out infinite;\n                        }\n                        \n                        &.rotate {\n                            animation: securityRotate 1s linear infinite;\n                        }\n                        \n                        &.glow {\n                            animation: securityGlow 2s ease-in-out infinite;\n                            filter: drop-shadow(0 0 10px currentColor);\n                        }\n                        \n                        &.success {\n                            color: #4ade80;\n                            animation: successPulse 0.6s ease-in-out;\n                        }\n                        \n                        &.error {\n                            color: #f87171;\n                            animation: errorShake 0.6s ease-in-out;\n                        }\n                    }\n                }\n            \n            .logo {\n                    width: 220px;\n                height: auto;\n                    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));\n                transition: transform 0.3s ease;\n                \n                &:hover {\n                    transform: scale(1.05);\n                }\n            }\n        }\n        \n            .brand-title {\n                font-size: 34px;\n                font-weight: 700;\n                margin-bottom: 16px;\n                line-height: 1.2;\n                min-height: 80px;\n                \n                .typing-text {\n                    display: inline-block;\n                    position: relative;\n                    color: white;\n                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n                    \n                    .cursor {\n                        display: inline-block;\n                        color: #4ade80;\n                        font-weight: 400;\n                        margin-left: 2px;\n                        opacity: 0;\n                        transition: opacity 0.1s ease;\n                        text-shadow: 0 0 8px #4ade80;\n                        animation: cursorGlow 2s ease-in-out infinite;\n                        \n                        &.visible {\n                            opacity: 1;\n                        }\n                    }\n                    \n                    &.typing-complete {\n                        .cursor {\n                            display: none;\n                        }\n                        \n                        text-shadow: \n                            0 2px 4px rgba(0, 0, 0, 0.3),\n                            0 0 20px rgba(255, 255, 255, 0.2);\n                    }\n                }\n            }\n\n            .brand-subtitle {\n                font-size: 18px;\n                opacity: 0.9;\n                margin-bottom: 30px;\n                line-height: 1.4;\n                animation: fadeInUp 1s ease-out 2s both;\n            }\n\n            .security-status {\n                margin-bottom: 30px;\n                padding: 15px 20px;\n                background: rgba(255, 255, 255, 0.1);\n                border-radius: 10px;\n                backdrop-filter: blur(10px);\n                border: 1px solid rgba(255, 255, 255, 0.2);\n\n                .status-indicator {\n                    display: flex;\n                    align-items: center;\n                    gap: 12px;\n\n                    .status-light {\n                        width: 8px;\n                        height: 8px;\n                        border-radius: 50%;\n                        background: #4ade80;\n                        animation: statusBlink 2s ease-in-out infinite;\n                    }\n\n                    .status-text {\n                        font-size: 14px;\n                        font-weight: 500;\n                        text-transform: uppercase;\n                        letter-spacing: 0.5px;\n                    }\n                }\n            }\n\n            .security-features {\n                display: flex;\n                flex-direction: column;\n                gap: 20px;\n\n                .feature {\n                    display: flex;\n                    align-items: center;\n                    gap: 12px;\n                    font-size: 16px;\n                    opacity: 0.9;\n                    position: relative;\n                    animation: slideInLeft 0.6s ease-out both;\n\n                    &:nth-child(1) { animation-delay: 3s; }\n                    &:nth-child(2) { animation-delay: 3.2s; }\n                    &:nth-child(3) { animation-delay: 3.4s; }\n\n                    svg {\n                        font-size: 20px;\n                        color: #4ade80;\n                    }\n\n                    .feature-bar {\n                        position: absolute;\n                        bottom: -5px;\n                        left: 32px;\n                        height: 2px;\n                        background: linear-gradient(90deg, #0c8479, transparent);\n                        width: 0;\n                        animation: barGrow 1s ease-out 0.5s both;\n                    }\n                }\n            }\n\n            .circuit-pattern {\n                position: absolute;\n                bottom: 20px;\n                right: 20px;\n                width: 100px;\n                height: 100px;\n                opacity: 0.1;\n                background-image: \n                    linear-gradient(90deg, white 1px, transparent 1px),\n                    linear-gradient(white 1px, transparent 1px);\n                background-size: 10px 10px;\n                animation: circuitGlow 4s ease-in-out infinite;\n            }\n        }\n    }\n\n    // Right side - Login Form\n    .login-panel {\n        flex: 1;\n        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        box-shadow: -10px 0 30px rgba(0, 0, 0, 0.2);\n        position: relative;\n\n        &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 1px;\n            height: 100%;\n            background: linear-gradient(to bottom, transparent, #0c8479, transparent);\n            animation: borderGlow 3s ease-in-out infinite;\n        }\n\n        .login-content {\n            width: 100%;\n            max-width: 420px;\n            padding: 60px 40px;\n            animation: slideInRight 0.8s ease-out 0.5s both;\n\n            .login-header {\n                text-align: center;\n                margin-bottom: 40px;\n\n                .access-indicator {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    gap: 10px;\n                    margin-bottom: 20px;\n                    \n                    .access-dots {\n                        display: flex;\n                        gap: 4px;\n                        \n                        span {\n                            width: 6px;\n                            height: 6px;\n                            border-radius: 50%;\n                            background: #0c8479;\n                            animation: dotPulse 1.5s ease-in-out infinite;\n                            \n                            &:nth-child(1) { animation-delay: 0s; }\n                            &:nth-child(2) { animation-delay: 0.2s; }\n                            &:nth-child(3) { animation-delay: 0.4s; }\n                        }\n                    }\n                    \n                    > span {\n                        font-size: 12px;\n                        font-weight: 600;\n                        color: #0c8479;\n                        letter-spacing: 1px;\n                    }\n                }\n\n                .login-title {\n                    font-size: 28px;\n                    font-weight: 600;\n                    color: #1e293b;\n                    margin-bottom: 8px;\n                }\n\n                .login-subtitle {\n                    font-size: 16px;\n                    color: #64748b;\n                    margin: 0;\n                }\n            }\n\n            .login-form {\n                .input-group {\n                    margin-bottom: 24px;\n                    position: relative;\n\n                    .input-scanner {\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        right: 0;\n                        height: 2px;\n                        background: linear-gradient(90deg, transparent, #0c8479, transparent);\n                        transform: translateX(-100%);\n                        animation: inputScan 3s ease-in-out infinite;\n                        z-index: 1;\n                    }\n\n                    .form-input {\n                        position: relative;\n                        \n                        input {\n                            height: 54px !important;\n                            border-radius: 12px !important;\n                            border: 2px solid #e2e8f0 !important;\n                            font-size: 16px !important;\n                            transition: all 0.3s ease !important;\n                            background: #ffffff !important;\n                            position: relative;\n\n                            &:focus {\n                                border-color: #0c8479 !important;\n                                box-shadow: 0 0 0 4px rgba(12, 132, 121, 0.1) !important;\n                                background: white !important;\n                                transform: translateY(-1px);\n                            }\n                            \n                            &:hover {\n                                border-color: #cbd5e1 !important;\n                                transform: translateY(-1px);\n                            }\n                        }\n\n                        label {\n                            font-weight: 600 !important;\n                            color: #374151 !important;\n                            margin-bottom: 8px !important;\n                            font-size: 14px !important;\n                        }\n                    }\n                }\n                \n                .login-button {\n                    margin-top: 32px;\n                    \n                    button {\n                        height: 54px !important;\n                        border-radius: 12px !important;\n                        font-size: 16px !important;\n                        font-weight: 600 !important;\n                        background: linear-gradient(135deg, #0c8479 0%, #0a736b 100%) !important;\n                        border: none !important;\n                        transition: all 0.3s ease !important;\n                        box-shadow: 0 4px 15px rgba(12, 132, 121, 0.3) !important;\n                        position: relative;\n                        overflow: hidden;\n\n                        &::before {\n                            content: '';\n                            position: absolute;\n                            top: 0;\n                            left: -100%;\n                            width: 100%;\n                            height: 100%;\n                            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);\n                            transition: left 0.5s ease;\n                        }\n                        \n                        &:hover {\n                            transform: translateY(-2px) !important;\n                            box-shadow: 0 8px 25px rgba(12, 132, 121, 0.4) !important;\n                            \n                            &::before {\n                                left: 100%;\n                            }\n                        }\n                        \n                        &:active {\n                            transform: translateY(0) !important;\n                        }\n\n                        &:disabled {\n                            opacity: 0.8 !important;\n                            transform: none !important;\n                            box-shadow: 0 2px 10px rgba(12, 132, 121, 0.2) !important;\n                        }\n                        \n                        &.loading {\n                            animation: buttonPulse 1.5s ease-in-out infinite;\n                        }\n                    }\n                }\n            }\n            \n            .login-footer {\n                margin-top: 40px;\n                text-align: center;\n                padding-top: 20px;\n                border-top: 1px solid #f1f5f9;\n\n                .security-badges {\n                    display: flex;\n                    justify-content: center;\n                    gap: 12px;\n                    margin-bottom: 16px;\n                    flex-wrap: wrap;\n\n                    .badge {\n                        padding: 4px 12px;\n                        background: #f1f5f9;\n                        border-radius: 20px;\n                        font-size: 11px;\n                        font-weight: 600;\n                        color: #64748b;\n                        text-transform: uppercase;\n                        letter-spacing: 0.5px;\n                        border: 1px solid #e2e8f0;\n                        animation: fadeInUp 0.6s ease-out both;\n                        \n                        &:nth-child(1) { animation-delay: 4s; }\n                        &:nth-child(2) { animation-delay: 4.2s; }\n                        &:nth-child(3) { animation-delay: 4.4s; }\n                    }\n                }\n                \n                p {\n                    font-size: 14px;\n                    color: #94a3b8;\n                    margin: 0;\n                }\n            }\n        }\n    }\n}\n\n// Loading Animations\n@keyframes overlayFadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes scannerRotate {\n    from { transform: translate(-50%, -50%) rotate(0deg); }\n    to { transform: translate(-50%, -50%) rotate(360deg); }\n}\n\n@keyframes gridDotPulse {\n    0%, 100% { opacity: 0; transform: scale(1); }\n    50% { opacity: 1; transform: scale(1.2); }\n}\n\n@keyframes shieldPulse {\n    0%, 100% { transform: translate(-50%, -50%) scale(1); }\n    50% { transform: translate(-50%, -50%) scale(1.1); }\n}\n\n@keyframes ringSpinFast {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n}\n\n@keyframes ringSpinSlow {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(-360deg); }\n}\n\n@keyframes textFade {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes progressShimmer {\n    0% { transform: translateX(-100%); }\n    100% { transform: translateX(100%); }\n}\n\n@keyframes loadingDotBounce {\n    0%, 80%, 100% { transform: scale(0); }\n    40% { transform: scale(1); }\n}\n\n// Animations\n@keyframes gridMove {\n    0% { transform: translate(0, 0); }\n    100% { transform: translate(50px, 50px); }\n}\n\n@keyframes scanMove {\n    0% { left: 0; opacity: 0; }\n    10% { opacity: 1; }\n    90% { opacity: 1; }\n    100% { left: 100%; opacity: 0; }\n}\n\n@keyframes backgroundPulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.7; }\n}\n\n@keyframes ringRotate {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n}\n\n@keyframes securityPulse {\n    0%, 100% { transform: scale(1); opacity: 1; }\n    50% { transform: scale(1.2); opacity: 0.7; }\n}\n\n@keyframes securityRotate {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n}\n\n@keyframes securityGlow {\n    0%, 100% { text-shadow: 0 0 5px currentColor; }\n    50% { text-shadow: 0 0 20px currentColor, 0 0 30px currentColor; }\n}\n\n@keyframes successPulse {\n    0% { transform: scale(1); }\n    50% { transform: scale(1.3); }\n    100% { transform: scale(1); }\n}\n\n@keyframes errorShake {\n    0%, 100% { transform: translateX(0); }\n    25% { transform: translateX(-5px); }\n    75% { transform: translateX(5px); }\n}\n\n@keyframes fadeInUp {\n    from { opacity: 0; transform: translateY(20px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes slideInLeft {\n    from { opacity: 0; transform: translateX(-30px); }\n    to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes slideInRight {\n    from { opacity: 0; transform: translateX(30px); }\n    to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes statusBlink {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.3; }\n}\n\n@keyframes barGrow {\n    from { width: 0; }\n    to { width: calc(100% - 32px); }\n}\n\n@keyframes circuitGlow {\n    0%, 100% { opacity: 0.1; }\n    50% { opacity: 0.3; }\n}\n\n@keyframes borderGlow {\n    0%, 100% { opacity: 0.3; }\n    50% { opacity: 1; }\n}\n\n@keyframes dotPulse {\n    0%, 100% { opacity: 0.3; transform: scale(1); }\n    50% { opacity: 1; transform: scale(1.2); }\n}\n\n@keyframes inputScan {\n    0% { transform: translateX(-100%); }\n    100% { transform: translateX(100%); }\n}\n\n@keyframes buttonPulse {\n    0%, 100% { box-shadow: 0 4px 15px rgba(12, 132, 121, 0.3); }\n    50% { box-shadow: 0 6px 20px rgba(12, 132, 121, 0.5); }\n}\n\n@keyframes cursorGlow {\n    0%, 100% { \n        text-shadow: 0 0 8px #4ade80;\n        transform: scale(1);\n    }\n    50% { \n        text-shadow: 0 0 15px #4ade80, 0 0 25px #4ade80;\n        transform: scale(1.05);\n    }\n}\n\n// Responsive Design\n@media (max-width: 1024px) {\n    .login-container {\n        .loading-overlay {\n            .loading-content {\n                padding: 30px 20px;\n                max-width: 350px;\n\n                .loading-scanner {\n                    width: 150px;\n                    height: 150px;\n                }\n            }\n        }\n\n        .login-brand {\n            .brand-content {\n                padding: 30px;\n                max-width: 380px;\n\n                .brand-title {\n                    font-size: 30px;\n                }\n\n                .brand-subtitle {\n                    font-size: 16px;\n                }\n            }\n        }\n\n        .login-panel {\n            .login-content {\n                padding: 40px 30px;\n                max-width: 380px;\n            }\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .login-container {\n        flex-direction: column;\n\n        .loading-overlay {\n            .loading-content {\n                padding: 20px;\n\n                .loading-scanner {\n                    width: 120px;\n                    height: 120px;\n                    margin-bottom: 20px;\n                }\n\n                .loading-text h3 {\n                    font-size: 20px;\n                }\n            }\n        }\n\n        .scan-line {\n            display: none;\n        }\n\n        .login-brand {\n            flex: 0 0 45%;\n            min-height: 45vh;\n\n            .brand-content {\n                padding: 20px;\n\n                .brand-logo {\n                    margin-bottom: 20px;\n\n                    .security-ring {\n                        width: 60px;\n                        height: 60px;\n                        margin-bottom: 15px;\n\n                        svg {\n                            font-size: 24px;\n                        }\n                    }\n\n                    .logo {\n                        width: 160px;\n                    }\n                }\n\n                .brand-title {\n                    font-size: 24px;\n                    margin-bottom: 10px;\n                }\n\n                .brand-subtitle {\n                    font-size: 14px;\n                    margin-bottom: 20px;\n                }\n\n                .security-status,\n                .security-features,\n                .circuit-pattern {\n                    display: none;\n                }\n            }\n        }\n\n        .login-panel {\n            flex: 1;\n            box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.1);\n\n            .login-content {\n                padding: 30px 20px;\n                max-width: 100%;\n\n                .login-header {\n                    margin-bottom: 30px;\n\n                    .login-title {\n                        font-size: 24px;\n                    }\n\n                    .login-subtitle {\n                        font-size: 14px;\n                    }\n                }\n\n                .login-form {\n                    .input-group {\n                        margin-bottom: 20px;\n                    }\n\n                    .login-button {\n                        margin-top: 20px;\n                    }\n                }\n\n                .login-footer {\n                    margin-top: 30px;\n                    \n                    .security-badges {\n                        .badge {\n                            font-size: 10px;\n                            padding: 3px 8px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media (max-width: 480px) {\n    .login-container {\n        .loading-overlay {\n            .loading-content {\n                .loading-scanner {\n                    width: 100px;\n                    height: 100px;\n                }\n\n                .loading-text h3 {\n                    font-size: 18px;\n                }\n            }\n        }\n\n        .login-brand {\n            min-height: 40vh;\n\n            .brand-content {\n                .brand-title {\n                    font-size: 20px;\n                }\n\n                .brand-subtitle {\n                    font-size: 13px;\n                }\n            }\n        }\n\n        .login-panel {\n            .login-content {\n                padding: 20px 15px;\n\n                .login-header {\n                    .login-title {\n                        font-size: 20px;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-container": `Login_login-container__KBpPh`,
	"fade-in": `Login_fade-in__tA3iO`,
	"loading-overlay": `Login_loading-overlay__CjHtp`,
	"overlayFadeIn": `Login_overlayFadeIn__fSvzR`,
	"loading-content": `Login_loading-content__l4-8c`,
	"loading-scanner": `Login_loading-scanner__mmGw6`,
	"scanner-line": `Login_scanner-line__49OHU`,
	"scannerRotate": `Login_scannerRotate__uo2fO`,
	"scanner-grid": `Login_scanner-grid__TgiW+`,
	"grid-dot": `Login_grid-dot__iSaQE`,
	"gridDotPulse": `Login_gridDotPulse__s4XKx`,
	"loading-icon": `Login_loading-icon__oQZ4n`,
	"loading-shield": `Login_loading-shield__L+8b5`,
	"shieldPulse": `Login_shieldPulse__rlwyz`,
	"loading-ring": `Login_loading-ring__1Dr9x`,
	"ringSpinFast": `Login_ringSpinFast__ikII7`,
	"ringSpinSlow": `Login_ringSpinSlow__lUME2`,
	"loading-text": `Login_loading-text__JiT1s`,
	"textFade": `Login_textFade__3iukh`,
	"loading-progress": `Login_loading-progress__U1RT3`,
	"progress-bar": `Login_progress-bar__3Q8IE`,
	"progress-fill": `Login_progress-fill__Q+wOz`,
	"progressShimmer": `Login_progressShimmer__AWxtr`,
	"progress-text": `Login_progress-text__LXSEM`,
	"loading-dots": `Login_loading-dots__xzCBr`,
	"loadingDotBounce": `Login_loadingDotBounce__gWtzY`,
	"login-brand": `Login_login-brand__gqAq6`,
	"grid-background": `Login_grid-background__Sx7wb`,
	"gridMove": `Login_gridMove__SjFLl`,
	"scan-line": `Login_scan-line__mBhQe`,
	"scanMove": `Login_scanMove__4k97U`,
	"backgroundPulse": `Login_backgroundPulse__zXOOp`,
	"brand-content": `Login_brand-content__GGUce`,
	"brand-logo": `Login_brand-logo__CuOC7`,
	"security-ring": `Login_security-ring__kXIqL`,
	"ringRotate": `Login_ringRotate__LxpbJ`,
	"pulse": `Login_pulse__0upYU`,
	"securityPulse": `Login_securityPulse__ZhvGM`,
	"rotate": `Login_rotate__8MXRP`,
	"securityRotate": `Login_securityRotate__Zc99x`,
	"glow": `Login_glow__KwpFf`,
	"securityGlow": `Login_securityGlow__EMpWl`,
	"success": `Login_success__gmvMK`,
	"successPulse": `Login_successPulse__vXPdS`,
	"error": `Login_error__MaX-D`,
	"errorShake": `Login_errorShake__i+HVa`,
	"logo": `Login_logo__-MCLA`,
	"brand-title": `Login_brand-title__xCYDs`,
	"typing-text": `Login_typing-text__muf5D`,
	"cursor": `Login_cursor__dTUp2`,
	"cursorGlow": `Login_cursorGlow__fbrvV`,
	"visible": `Login_visible__IQSdu`,
	"typing-complete": `Login_typing-complete__dH0v9`,
	"brand-subtitle": `Login_brand-subtitle__emUJn`,
	"fadeInUp": `Login_fadeInUp__5uC8K`,
	"security-status": `Login_security-status__uy6iC`,
	"status-indicator": `Login_status-indicator__gEB9y`,
	"status-light": `Login_status-light__zioIu`,
	"statusBlink": `Login_statusBlink__JgvWn`,
	"status-text": `Login_status-text__aWNDB`,
	"security-features": `Login_security-features__SzvaI`,
	"feature": `Login_feature__2xXRN`,
	"slideInLeft": `Login_slideInLeft__XFIH2`,
	"feature-bar": `Login_feature-bar__ftxs1`,
	"barGrow": `Login_barGrow__XcKgi`,
	"circuit-pattern": `Login_circuit-pattern__vvpS8`,
	"circuitGlow": `Login_circuitGlow__b3cyV`,
	"login-panel": `Login_login-panel__VsVIb`,
	"borderGlow": `Login_borderGlow__jW+z2`,
	"login-content": `Login_login-content__L7paK`,
	"slideInRight": `Login_slideInRight__mBdHP`,
	"login-header": `Login_login-header__-UIph`,
	"access-indicator": `Login_access-indicator__E3LLi`,
	"access-dots": `Login_access-dots__TS0Mh`,
	"dotPulse": `Login_dotPulse__tx--u`,
	"login-title": `Login_login-title__i+aCA`,
	"login-subtitle": `Login_login-subtitle__rb2SR`,
	"login-form": `Login_login-form__XkcPR`,
	"input-group": `Login_input-group__5Qkc9`,
	"input-scanner": `Login_input-scanner__8SiVi`,
	"inputScan": `Login_inputScan__mNzTn`,
	"form-input": `Login_form-input__LsgZg`,
	"login-button": `Login_login-button__9zGQq`,
	"loading": `Login_loading__MkPQ2`,
	"buttonPulse": `Login_buttonPulse__rl9jr`,
	"login-footer": `Login_login-footer__+PtkH`,
	"security-badges": `Login_security-badges__DvaI6`,
	"badge": `Login_badge__uVoAv`
};
export default ___CSS_LOADER_EXPORT___;
